<template>
  <div class="maintenance-container">
    <div class="tips">
      <h2>{{ data.title }}</h2>
      <h4 v-html="data.memo"></h4>
    </div>
  </div>
</template>

<script>
import {getRequest} from '@/common/libs/request';
import {RELEASE_JSON_URL} from "@/common/utils/utils";

export default {
  data() {
    return {
      data: '',
    };
  },
  created() {
    this.getMaintenanceInfo();
  },
  methods: {
    // 获取通知信息
    getMaintenanceInfo() {
      // postRequest('/api/eda/common/eda/getCosApi', {
      //   key: 'notice.json',
      //   dir: 'public',
      //   contentType: 'text/html',
      // })
      getRequest(`${RELEASE_JSON_URL}?${new Date().getTime()}`).then((res) => {
        if (res.state === 'failed') {
          this.$router.push('/login');
        }

        this.data = res;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.maintenance-container {
  height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;

  .tips {
    margin: 0 auto;
    text-align: center;
    color: #006EFF;
  }

  h2 {
    font-size: 36px;
    margin-bottom: 30px;
    letter-spacing: 4px;
  }

  h4 {
    line-height: 38px;
    font-weight: normal;
    font-size: 18px;
    color: #000;
  }
}
</style>
